import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import CourseSearch from './CourseSearch';

class CourseSidebar extends Component {
    render() {
        return (
            <div className="course-sidebar">
                <Row>
                    <Col md="12">
                        <CourseSearch _getEventSearch = {this.props._getEventSearch}/>
                    </Col>
                  
                </Row>
            </div>
        )
    }
}

export default CourseSidebar
